const isPresent = (value) =>
  value !== null && value !== undefined && String(value).trim() !== "";

const parseDateOnly = (value) => {
  const raw = String(value || "").slice(0, 10);
  const match = /^(\d{4})-(\d{2})-(\d{2})$/.exec(raw);
  if (!match) return null;
  const [, y, m, d] = match.map(Number);
  const date = new Date(y, m - 1, d);
  return Number.isFinite(date.getTime()) ? date : null;
};

const monthsOld = (date, now) =>
  (now.getFullYear() - date.getFullYear()) * 12 + (now.getMonth() - date.getMonth())
  - (now.getDate() < date.getDate() ? 1 : 0);

export const attentionReasons = (asset, opts = {}) => {
  if (opts.isNotes) {
    const daysLate = Number(opts.note?.computed_days_late || 0);
    return daysLate > 0
      ? [{ id: "note_late", kind: "alert", label: `${Math.round(daysLate)} days late` }]
      : [];
  }

  const reasons = [];
  const value = Number(asset?.current_value);
  if (!Number.isFinite(value) || value <= 0) {
    reasons.push({ id: "value", kind: "gap", label: "No current value" });
  }

  if (isPresent(asset?.value_as_of)) {
    const valueDate = parseDateOnly(asset.value_as_of);
    if (valueDate && monthsOld(valueDate, new Date()) >= 24) {
      reasons.push({ id: "value_stale", kind: "gap", label: `Value date is stale (${String(asset.value_as_of).slice(0, 10)})` });
    }
  }

  if (!isPresent(asset?.address) && !isPresent(asset?.address_parts?.street)) {
    reasons.push({ id: "address", kind: "gap", label: "No address" });
  }

  if (
    asset?.asset_type === "real_estate" &&
    Array.isArray(asset.tax_records) &&
    asset.tax_records.some((t) => t.status === "delinquent")
  ) {
    reasons.push({ id: "delinquent", kind: "alert", label: "Property tax delinquent" });
  }

  if (asset?.lease_alert) {
    reasons.push({ id: "lease", kind: "alert", label: "Lease needs attention" });
  }

  return reasons;
};
